// @ts-strict-ignore
import { graphql } from 'react-relay';
import type { SelectorStoreUpdater } from 'relay-runtime/lib/store/RelayStoreTypes';
import { getRelayEnvironment } from '@/RelayEnvironment';
import commitMutationPromise from '../../services/commitMutationPromise';
import type { RemoveRecipientsFromListMutation$data } from './__generated__/RemoveRecipientsFromListMutation.graphql';
//Debug
//import storeDebugger from 'relay-runtime/lib/RelayStoreProxyDebugger'

export const RemoveRecipientsFromListMutation = graphql`
    mutation RemoveRecipientsFromListMutation(
        $input: RemoveRecipientsFromListInput!
    ) {
        removeRecipientsFromList(input: $input) {
            success
            updatedCaches
        }
    }
`;

/* You can use emailAddresses + phoneNumbers pair or respondentIds without phones\emails */
export type RemoveRecipientsFromListMutationProps = {
    recipientListId: string;
    emailAddresses?: string[];
    phoneNumbers?: string[];
    respondentIds?: string[];
};

export default commitRemoveRecipientsFromListMutation;
export async function commitRemoveRecipientsFromListMutation({
    recipientListId,
    emailAddresses = [],
    phoneNumbers = [],
    respondentIds = [],
}: RemoveRecipientsFromListMutationProps) {
    const variables = {
        input: {
            recipientListId,
            emailAddresses,
            phoneNumbers,
            respondentIds,
        },
    };

    const sharedUpdater: SelectorStoreUpdater<
        RemoveRecipientsFromListMutation$data
    > = (store) => {
        const recipientList = store.get(recipientListId);

        const recipients = recipientList.getLinkedRecords('recipients');

        recipientList.setLinkedRecords(
            recipients.filter((recipient) => {
                const emailAddress = recipient.getValue(
                    'emailAddress',
                ) as string;
                const phoneNumber = recipient.getValue('phoneNumber') as string;
                const respondentId = recipient.getValue(
                    'respondentId',
                ) as string;

                return (
                    !emailAddresses.includes(emailAddress) &&
                    !phoneNumbers.includes(phoneNumber) &&
                    !respondentIds.includes(respondentId)
                );
            }),
            'recipients',
        );
        const recipientCount = recipientList.getValue(
            'recipientCount',
        ) as number;
        const removedCount =
            emailAddresses.length + phoneNumbers.length + respondentIds.length;
        if (recipientCount !== undefined) {
            recipientList.setValue(
                recipientCount - removedCount,
                'recipientCount',
            );
        }
        // todo Decrease responseCount. But only if the respondent actually responded
    };

    return await commitMutationPromise(getRelayEnvironment(), {
        mutation: RemoveRecipientsFromListMutation,
        variables,
        optimisticUpdater: sharedUpdater,
        updater: sharedUpdater,
    });
}
